import {
  PbEcommerceContact,
  PbEcommerceContactTypeEnum
} from '@itsrever/rever-api'
import { ContactType, EcommerceContact } from '@/domain/ecommerce-contact'

const TYPE_BY_API_VALUE: Record<string, ContactType> = {
  [PbEcommerceContactTypeEnum.CustomerService]: 'CUSTOMER_SERVICE',
  [PbEcommerceContactTypeEnum.Logistics]: 'LOGISTICS',
  [PbEcommerceContactTypeEnum.Invoicing]: 'INVOICING',
  [PbEcommerceContactTypeEnum.TechnicalSupport]: 'TECHNICAL_SUPPORT',
  [PbEcommerceContactTypeEnum.Commercial]: 'COMMERCIAL'
}

const API_VALUE_BY_TYPE: Record<ContactType, PbEcommerceContactTypeEnum> = {
  CUSTOMER_SERVICE: PbEcommerceContactTypeEnum.CustomerService,
  LOGISTICS: PbEcommerceContactTypeEnum.Logistics,
  INVOICING: PbEcommerceContactTypeEnum.Invoicing,
  TECHNICAL_SUPPORT: PbEcommerceContactTypeEnum.TechnicalSupport,
  COMMERCIAL: PbEcommerceContactTypeEnum.Commercial
}

export function toEcommerceContacts(
  contacts: PbEcommerceContact[]
): EcommerceContact[] {
  return contacts.flatMap((contact) => {
    const type = TYPE_BY_API_VALUE[contact.type ?? '']
    if (!type) return []
    return [
      {
        type,
        name: contact.name ?? '',
        email: contact.email ?? '',
        phone: contact.phone ?? ''
      }
    ]
  })
}

// Types this dashboard does not know yet, kept so a full-list save does not delete them.
export function unsupportedContacts(
  contacts: PbEcommerceContact[]
): PbEcommerceContact[] {
  return contacts.filter((contact) => !TYPE_BY_API_VALUE[contact.type ?? ''])
}

export function toApiContacts(
  contacts: EcommerceContact[]
): PbEcommerceContact[] {
  return contacts.map((contact) => ({
    type: API_VALUE_BY_TYPE[contact.type],
    name: contact.name,
    email: contact.email,
    phone: contact.phone
  }))
}
